<nb-actions>
    <nb-action>
        <span class="title">{{title}}</span>
    </nb-action>
    <nb-action *ngFor="let breadCrumbLink of breadCrumbLinks; index as i">
        <ng-container *ngIf="breadCrumbLink.state == 'active';else inactive">
            <span class="breadCrumbLink active" (click)="breadCrumbLinkSelected(breadCrumbLink.level)">
                <ng-container *ngIf="breadCrumbLink.level != 1">
                    &nbsp;&nbsp;&gt;&nbsp;&nbsp;
                </ng-container>
                {{breadCrumbLink?.displayText}}
            </span>
        </ng-container>
        <ng-template #inactive>
            <ng-container *ngIf="breadCrumbLink.level > 1">
                &nbsp;&nbsp;&gt;&nbsp;&nbsp;
            </ng-container>
            <ng-container *ngIf="activeAction === 'list';else action">
                <ng-container *ngIf="breadCrumbLink.selected;else notSelected">
                    <span class="breadCrumbLink disabled selected">{{breadCrumbLink?.displayText}}</span>
                </ng-container>
                <ng-template #notSelected>
                    <span class="breadCrumbLink disabled">{{breadCrumbLink?.displayText}}</span>
                </ng-template>
            </ng-container>
            <ng-template #action>
                <span class="breadCrumbLink active" (click)="breadCrumbLinkSelected(breadCrumbLink.level)">{{breadCrumbLink?.displayText}}</span>
            </ng-template>
        </ng-template>
    </nb-action>
    <nb-action *ngIf="activeAction === 'edit'">
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #editBreadCrumb class="breadCrumbAction active disabled" (click)="setEdit()">{{editText}}</span>
    </nb-action>
    <nb-action *ngIf="activeAction === 'list'">
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #createBreadCrumb class="breadCrumbAction inactive" (click)="loadCreate(level)"> {{addText}}</span>
    </nb-action>

    <!-- <div [ngSwitch]="activeAction">
        <ng-container *ngSwitchCase="'edit'">
            <nb-action>
                &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #editBreadCrumb class="breadCrumbAction active disabled">{{editText}}</span>
            </nb-action>
        </ng-container>
        <ng-container *ngSwitchCase="'list'">
            <nb-action>
                &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #createBreadCrumb class="breadCrumbAction inactive" (click)="loadCreate(level)">{{addText}}</span>
            </nb-action>
        </ng-container>
        
        
        
    </div> -->
    
    <!-- <nb-action *ngIf="edit || !list">
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #editBreadCrumb class="breadCrumbAction active disabled">{{editText}}</span>
    </nb-action>
    <nb-action *ngIf="!edit || list">
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span #createBreadCrumb class="breadCrumbAction inactive" (click)="loadCreate(level)">{{addText}}</span>
    </nb-action> -->
    <!-- <nb-action *ngIf="hasContextMenu">
        &nbsp;&nbsp;&gt;&nbsp;&nbsp;<span [nbContextMenu]="items" nbContextMenuTag="contextMenu" nbContextMenuPlacement="bottom">Related</span>
    </nb-action> -->
    
</nb-actions>

